


class FilterHandler {

	constructor() {
		this.filters = [];
		this.mainContainer = document.querySelector(".wpfMainWrapper");

		if(this.mainContainer) {
			console.log(this.mainContainer);
			this.filters = this.mainContainer.querySelectorAll(".wpfFilterContent");
			this.run();
		}
	}


	run() {
		// For each filter in the filters array check for only one child li element
		this.filters.forEach(filter => {
			const children = filter.querySelectorAll("li");
			const description = filter.querySelector(".wfpDescription");
			if (children.length === 1) {
				// replace the text of the wpfFilterTaxNameWrapper with the text of description
				const taxName = filter.querySelector(".wpfFilterTaxNameWrapper");
				taxName.innerHTML = description.innerHTML;
				// remove the description
				// Wrap taxname in a strong tag
				taxName.innerHTML = `<strong>${taxName.innerHTML}</strong>`;
				description.remove();
			}
			});


			// if the width of the document inner width is less than 768px
			if (window.innerWidth < 768) {
				document.querySelector(".product-filter-accordion").classList.remove("cc-accordion-active");
				document.querySelector(".product-filter-accordion").classList.add("cc-accordion-hidden");
			}
		}

}


export default FilterHandler;
